module.exports = __webpack_public_path__ + "static/img/onde.c5991f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/onde.svg
// module id = 590
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12